/** W/D/L/GF-GA/PTS columns shared by group and best-third standings tables. */
import { standingsGamesPlayed } from "@/lib/groupStandings";

export function StandingsStatHeaderCells({ t }) {
  return (
    <>
      <th className="w-7" title={t("flat.colGPFull")}>
        {t("flat.colGP")}
      </th>
      <th className="w-7">W</th>
      <th className="w-7">D</th>
      <th className="w-7">L</th>
      <th className="w-11">GF-GA</th>
      <th className="w-7 pl-1">P</th>
    </>
  );
}

export function StandingsStatBodyCells({ row }) {
  const gp = standingsGamesPlayed(row);
  return (
    <>
      <td className="text-center">{gp}</td>
      <td className="text-center">{row.W}</td>
      <td className="text-center">{row.D}</td>
      <td className="text-center">{row.L}</td>
      <td className="text-center">
        {row.GF}-{row.GA}
      </td>
      <td className="text-center text-[var(--accent)] pl-1">{row.PTS}</td>
    </>
  );
}

/** FIFA WC 2026: 8 of 12 third-placed teams advance. */
export const BEST_THIRD_ADVANCE_COUNT = 8;

export function bestThirdRowClassName(index, total) {
  const base = "border-t border-[var(--line)]";
  if (total > BEST_THIRD_ADVANCE_COUNT && index === BEST_THIRD_ADVANCE_COUNT - 1) {
    return `${base} border-b-2 border-b-[var(--accent)]`;
  }
  return base;
}
